const SYRAPAY_MERCHANT_PORTAL_PERMISSION = 'merchantPortal';

export { SYRAPAY_MERCHANT_PORTAL_PERMISSION };
